import TestimonialSection from "../components/testimonial/testimonial-section";
import BreadcrumbOne from "./../components/common/breadcrumb/breadcrumb-one";
export default function Testimonial() {
	return (
		<>
			<BreadcrumbOne title="Testimonial" />
			<TestimonialSection />
		</>
	);
}
